/* Rylo offer block: bundle tiers, gifts, delivery date, AJAX add-to-cart -> cart drawer, sticky bar */
const ryNum = (s) => parseFloat(String(s || '').replace(/[^0-9.]/g, '')) || 0;

function initRyOffer(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const tiers = [...root.querySelectorAll('.ry-tier')];
  const gift3 = root.querySelector('.ry-gift[data-unlock]');
  const sticky = root.querySelector('[data-ry-sticky]');
  const msg = root.querySelector('.ry-atc-msg');
  let current = tiers.find((t) => t.classList.contains('is-active')) || tiers[0];

  /* round the discount badge the same way the source does (66.5% -> 67%) */
  tiers.forEach((t) => {
    const compare = ryNum(t.dataset.compare);
    [['price', 'off', '.ry-tier__off:not(.ry-sb)'], ['sprice', 'soff', '.ry-tier__off.ry-sb']].forEach(([pk, ok, sel]) => {
      const price = ryNum(t.dataset[pk]);
      if (compare > price && price > 0) {
        const off = Math.round((1 - price / compare) * 100);
        t.dataset[ok] = off;
        const badge = t.querySelector(sel);
        if (badge) badge.textContent = badge.textContent.replace(/^\d+%/, `${off}%`);
      }
    });
  });

  /* subscribe & save: checkbox switches prices and adds the selling plan to the main line */
  const subCb = root.querySelector('[data-ry-sub]');
  const isSub = () => !!(subCb && subCb.checked && root.dataset.plan);

  function paint() {
    tiers.forEach((t) => {
      const on = t === current;
      t.classList.toggle('is-active', on);
      t.querySelector('input').checked = on;
    });
    if (gift3) gift3.classList.toggle('is-locked', Number(current.dataset.tier) < Number(gift3.dataset.unlock));
    root.classList.toggle('is-sub', isSub());
    if (subCb) subCb.closest('.ry-sub').classList.toggle('is-on', subCb.checked);
    if (sticky) {
      const off = Number(isSub() ? current.dataset.soff : current.dataset.off);
      sticky.querySelector('[data-ry-sp]').textContent = isSub() ? current.dataset.sprice : current.dataset.price;
      sticky.querySelector('[data-ry-sc]').textContent = off > 0 ? current.dataset.compare : '';
      const s = sticky.querySelector('[data-ry-ss]');
      s.textContent = off > 0 ? `${root.dataset.saveLabel} ${off}%` : '';
      s.style.display = off > 0 ? '' : 'none';
    }
  }
  tiers.forEach((t) => t.addEventListener('click', (e) => { e.preventDefault(); current = t; paint(); }));
  if (subCb) subCb.addEventListener('change', paint);
  paint();

  const dv = root.querySelector('.ry-deliv');
  if (dv) {
    const d = new Date();
    let add = Number(dv.dataset.days) || 3;
    while (add > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 6) add--; }
    dv.querySelector('.ry-deliv__date').textContent = d.toLocaleDateString('he-IL', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  async function post(items) {
    return fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
  }

  async function addToCart(btn) {
    btn.setAttribute('aria-busy', 'true');
    if (msg) msg.textContent = '';
    const items = [{ id: Number(current.dataset.variant), quantity: 1 }];
    if (isSub()) items[0].selling_plan = Number(root.dataset.plan);
    try {
      /* gifts once per cart */
      let inCart = [];
      try { inCart = (await (await fetch(`${root.dataset.cartUrl}.js`)).json()).items.map((i) => i.variant_id); } catch (e) { /* ignore */ }
      (root.dataset.giftIds || '').split(',').filter(Boolean).map(Number)
        .filter((id) => !inCart.includes(id))
        .forEach((id) => items.push({ id, quantity: 1, properties: { _gift: 'Rylo' } }));
      /* the cart lists the most recently added line first: send the gifts first so the product shows on top */
      let res = await post([...items.slice(1), items[0]]);
      if (!res.ok && items.length > 1) res = await post([items[0]]);
      if (!res.ok) throw new Error('add failed');
      const cart = await (await fetch(`${root.dataset.cartUrl}.js`)).json();
      try {
        const { CartAddEvent } = await import('@theme/events');
        document.dispatchEvent(new CartAddEvent({}, 'rylo-offer', { source: 'rylo-offer', itemCount: cart.item_count, productId: root.dataset.pid }));
      } catch (e) { /* theme events unavailable */ }
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') setTimeout(() => drawer.open(), 150);
      else window.location.href = root.dataset.cartUrl;
    } catch (err) {
      if (msg) msg.textContent = root.dataset.error;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }
  root.querySelectorAll('[data-ry-atc]').forEach((b) => b.addEventListener('click', () => addToCart(b)));

  if (sticky) {
    document.body.appendChild(sticky);
    const mainBtn = root.querySelector('.ry-atc');
    new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(mainBtn);
  }
  if (!document.querySelector('link[data-ry3]')) {
    const l = document.createElement('link'); l.rel = 'stylesheet'; l.dataset.ry3 = '1';
    l.href = new URL('rylo-3.css', import.meta.url).href; document.head.appendChild(l);
  }
}
document.querySelectorAll('.ry-offer').forEach(initRyOffer);
document.addEventListener('shopify:section:load', () => document.querySelectorAll('.ry-offer').forEach(initRyOffer));